import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Formik, Form } from "formik";
import { Grid, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import { getSmartkioskInitialValues } from "app/pages/customers/dsok/utils/getSmartkioskInitialValues";
import SmartkioskDynamicComponents from "app/pages/customers/dsok/smartkioskFields/SmartkioskDynamicComponents";
import { SETTINGS_FIELD_SCHEMA } from "app/pages/customers/dsok/smartkioskFields/SmartkioskSettingsFields";
import { DSOK_CUSTOMER_FIELD_SCHEMA } from "app/pages/customers/dsok/smartkioskFields/SmartkioskCustomerFields";
import DsokCustomerDetailLayout from "../components/DsokCustomerDetailLayout";
import DsokCustomerDetailDirtySync from "../components/DsokCustomerDetailDirtySync";
import DsokCustomerDetailSectionRegister from "../components/DsokCustomerDetailSectionRegister";
import { useDsokCustomerDetail } from "../data/useDsokCustomerDetail";

const DYNAMIC_COMPONENTS_FIELD_NAME = "DYNAMIC_COMPONENTS_FIELD";

const DsokCustomerDynamicComponentsPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const auth = useJumboAuth();
  const authUser = auth?.getAuthUser?.() || {};
  const userTyp = authUser?.type ?? authUser?.typ ?? 1;
  const isAdmin = userTyp === 1;
  const { customer, customerUrl, hasEasyBuy } = useDsokCustomerDetail();
  const [expanded, setExpanded] = useState(DYNAMIC_COMPONENTS_FIELD_NAME);
  const handleChange = (panel) => (_event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const formInitialValues = useMemo(() => {
    if (!customer) {
      return { customer: { ...DSOK_CUSTOMER_FIELD_SCHEMA }, settings: { ...SETTINGS_FIELD_SCHEMA } };
    }
    return getSmartkioskInitialValues(customer) ?? { customer: { ...DSOK_CUSTOMER_FIELD_SCHEMA }, settings: { ...SETTINGS_FIELD_SCHEMA } };
  }, [customer]);

  useEffect(() => {
    if (!hasEasyBuy) {
      navigate(`/dsok/customer-detail/${customerUrl}`, { replace: true });
    }
  }, [hasEasyBuy, customerUrl, navigate]);

  if (!hasEasyBuy) {
    return null;
  }
  return (
    <DsokCustomerDetailLayout lastBreadcrumbLabel={t("dsokCustomerDetail.sections.dynamicComponents.title")}>
      <Paper variant="outlined" sx={{ bgcolor: "background.paper", p: 2, borderRadius: 1 }}>
        <Formik initialValues={formInitialValues} enableReinitialize onSubmit={() => {}}>
          <Form>
            <DsokCustomerDetailDirtySync />
            <DsokCustomerDetailSectionRegister
              sectionId="dynamic-components"
              getPayload={(values) => values.settings?.smartkiosk?.dynamicComponents ?? {}}
            />
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <SmartkioskDynamicComponents handleChange={handleChange} expanded={expanded} hideSectionTitle />
              </Grid>
            </Grid>
          </Form>
        </Formik>
      </Paper>
    </DsokCustomerDetailLayout>
  );
};

export default DsokCustomerDynamicComponentsPage;
